import React, { useEffect, useRef, useState } from "react";
import Modal from "../../../../components/Modal";
import PropTypes from "prop-types";
import Form from "../Form";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  addTraderMarketOfferNegotiationProposalReasonsDetails,
  traderMarketOfferNegotiationProposalReasonsDetails,
  traderMarketOfferNegotiationProposalReasonsDetailsReset,
  updateTraderMarketOfferNegotiationProposalReasonsDetails,
} from "../../../../actions";
import { adaptInitialFormValues, getTitleName } from "../../../../utils/wfpManagerConfigurationUtils";

export const TraderMarketOfferNegotiationProposalReasonsEditModal = ({
  initialFormValues,
  isFetching,
  errorMessage,
  modalOptions,
  setModalOptions,
  traderMarketOfferNegotiationProposalReasonsDetails,
  traderMarketOfferNegotiationProposalReasonsDetailsReset,
  updateTraderMarketOfferNegotiationProposalReasonsDetails,
  addTraderMarketOfferNegotiationProposalReasonsDetails,
}) => {

  const { t } = useTranslation();
  const buttonRef = useRef();
  const [initialValues, setInitialValues] = useState();

  useEffect(() => {
    traderMarketOfferNegotiationProposalReasonsDetails(modalOptions.id);
    return () => {
      traderMarketOfferNegotiationProposalReasonsDetailsReset();
    };
  }, [modalOptions.id]);

  useEffect(() => {
    setInitialValues(adaptInitialFormValues(initialFormValues, modalOptions.id));
  }, [initialFormValues]);

  const onSubmitEdit = (formValues) => {
    updateTraderMarketOfferNegotiationProposalReasonsDetails(modalOptions.id, formValues);
  };

  const onSubmitCreate = (formValues) => {
    addTraderMarketOfferNegotiationProposalReasonsDetails(formValues);
  };

  const onSubmit = (formValues) => {
    switch(modalOptions.type){
    case "edit":
      onSubmitEdit(formValues);
      break;
    case "create":
      onSubmitCreate(formValues);
      break;
    default:
      break;
    }
    setModalOptions({ type: undefined, id: undefined, isOpen: false });
  };

  return (
    <Modal
      isOpen={modalOptions.isOpen}
      title={
        t("configuration.item.traderMarketOfferNegotiationProposalReasons") + " " + t(getTitleName(modalOptions.type))
      }
      onCancel={() => setModalOptions({ type: undefined, isOpen: false, id: undefined })}
      onValidate={() => buttonRef.current.click()}
      hideCancelButton={modalOptions.type === "view" ? true : false}
      validateText={modalOptions.type !== "view" ? t("negotiationCard.confirm") : t("common.back")}
    >
      <Form
        id={modalOptions.id}
        initialValues={initialValues}
        isFetching={isFetching}
        errorMessage={errorMessage}
        modalOptions={modalOptions}
        onSubmit={onSubmit}
        buttonRef={buttonRef}
      />
    </Modal>
  );
};

TraderMarketOfferNegotiationProposalReasonsEditModal.defaultProps = {};

TraderMarketOfferNegotiationProposalReasonsEditModal.propTypes = {
  initialFormValues: PropTypes.object,
  isFetching: PropTypes.bool,
  errorMessage: PropTypes.string,
  modalOptions: PropTypes.object,
  setModalOptions: PropTypes.func,
  traderMarketOfferNegotiationProposalReasonsDetails: PropTypes.func.isRequired,
  traderMarketOfferNegotiationProposalReasonsDetailsReset: PropTypes.func.isRequired,
  updateTraderMarketOfferNegotiationProposalReasonsDetails: PropTypes.func.isRequired,
  addTraderMarketOfferNegotiationProposalReasonsDetails: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  return {
    initialFormValues: state.traderMarketOfferNegotiationProposalReasonsDetails.data,
    isFetching: state.traderMarketOfferNegotiationProposalReasonsDetails.isFetching,
    errorMessage: state.traderMarketOfferNegotiationProposalReasonsDetails.errorMessage,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    traderMarketOfferNegotiationProposalReasonsDetails: (id) => dispatch(traderMarketOfferNegotiationProposalReasonsDetails(id)),
    traderMarketOfferNegotiationProposalReasonsDetailsReset: () => dispatch(traderMarketOfferNegotiationProposalReasonsDetailsReset()),
    addTraderMarketOfferNegotiationProposalReasonsDetails: (values) =>
      dispatch(addTraderMarketOfferNegotiationProposalReasonsDetails(values, "", true)),
    updateTraderMarketOfferNegotiationProposalReasonsDetails: (id, values) =>
      dispatch(updateTraderMarketOfferNegotiationProposalReasonsDetails(id, values, "", true)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TraderMarketOfferNegotiationProposalReasonsEditModal);
